'use client'

import Link from 'next/link'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { Logo } from '@/components/Logo'

export function GuestAuthDialog({
  open,
  onOpenChange,
  heading = 'Sign in to Atrium',
  body = 'Create a free account or sign in to access this feature.',
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  heading?: string
  body?: string
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[min(calc(100vw-2rem),22rem)] rounded-2xl border-0 p-8 text-center shadow-2xl">
        <DialogTitle className="sr-only">{heading}</DialogTitle>
        <div className="mb-5 flex justify-center">
          <div className="flex size-[64px] items-center justify-center overflow-hidden rounded-2xl shadow-md">
            <Logo variant="mark" width={64} height={64} className="size-[64px]" />
          </div>
        </div>
        <h2 className="text-[20px] font-extrabold leading-tight tracking-tight text-atrium-black">
          {heading}
        </h2>
        <p className="mt-2 text-[14px] leading-relaxed text-atrium-muted">
          {body}
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <Link
            href="/signup"
            onClick={() => onOpenChange(false)}
            className="flex w-full items-center justify-center rounded-xl bg-accent-600 px-5 py-3 text-[14px] font-bold text-white transition hover:bg-accent-700 active:scale-[0.98]"
          >
            Create a free account
          </Link>
          <Link
            href="/login"
            onClick={() => onOpenChange(false)}
            className="flex w-full items-center justify-center rounded-xl border-2 border-atrium-border bg-atrium-content px-5 py-3 text-[14px] font-semibold text-atrium-black transition hover:bg-atrium-border active:scale-[0.98]"
          >
            Sign in
          </Link>
        </div>
        <p className="mt-5 text-[11px] text-atrium-muted">
          By continuing you agree to Atrium&apos;s{' '}
          <Link href="/terms" onClick={() => onOpenChange(false)} className="underline opacity-70 hover:opacity-100">
            Terms of Service
          </Link>.
        </p>
      </DialogContent>
    </Dialog>
  )
}
